// on page load find all elements with [data-sticky]
// add each element to array in window.stickyManager as element
// {
//   el: element,
//   height: 0, ( element.offsetHeight )
//   top: 0,
// }
// add stickyUpdate eventListeners for each element on window resize and scroll
// stickyUpdate resets element height and top position
// run stickyUpdate

window.stickyManager = []
const stickyElements = document.querySelectorAll('[data-sticky-bar]:not(.jumpLinks), .actionBar')

const getTop = (index) => {
    // if first item, return 0
    if (index === 0) {
        return 0
    }

    const elAbove = window.stickyManager[index - 1]
    const newTop = elAbove.el.offsetHeight + elAbove.top - 2
    return newTop
}

const updateStickyElements = (el, index, addStyle = true) => {
    window.stickyManager[index].height = el.offsetHeight
    window.stickyManager[index].top = getTop(index)
    if (addStyle) {
        el.style.top = getTop(index) + 'px'
    } else {
        el.style.top = 'auto'
    }
}

// Updates stickyHeight in window with total height of all sticky elements combined.
const updateStickyHeight = () => {
    let newHeight = 0
    window.stickyManager.forEach((obj) => {
        newHeight = newHeight + obj.height
    })
    window.stickyHeight = newHeight
}

// on resize of window or elements, update
const resizeCallback = (entries) => {
    // Prevent resize observer loop limit from exceeding.
    window.requestAnimationFrame(() => {
        entries.forEach((entry, index) => {
            const currentHeight = window.stickyManager[index].height
            const target = window.stickyManager[index]
            const addStyle = window.innerWidth >= 850
            updateStickyElements(target.el, index, addStyle)
            updateStickyHeight()
            if (Math.round(entry.contentRect.height) !== currentHeight) {
            }
        })
    })
}
const resizeObserver = new ResizeObserver(resizeCallback)

// build sticky elements
stickyElements.forEach((el, index) => {
    window.stickyManager = [...window.stickyManager, {
        el: el,
        height: 0,
        top: 0,
    }]
    updateStickyElements(el, index)
    updateStickyHeight()
    resizeObserver.observe(el)
})
